import WIDGETS from './widgets';

export default {
	name: 'ticket_referral_answer',
	spacing: 2,
	widgets: [{ content: WIDGETS.SURVEYS, breakpoints: { xs: 12 }, lazy_loading: 0 }],
};
